<script setup>
const { model } = defineProps(['model'])

const heading = computed(() => model?.heading?.value ?? '')

const categoryId = computed(
  () => model?.articleFeedPage?.expandedValue?.contentLink?.id ?? null,
)

const showArticleSummaries = computed(
  () => model?.showArticleSummaries?.value ?? false,
)

const showArticleTopics = computed(
  () => model?.showArticleTopics?.value ?? false,
)

const maxArticleCount = computed(() => {
  return model?.maxArticleCount?.value ?? 3
})

const {
  data,
  pending,
} = usePaginatedArticles(categoryId)

const articles = computed(() => {
  const items = data?.value?.articles ?? []

  return items.slice(0, maxArticleCount.value)
})
</script>

<template>
  <div class="article-feed-block block-spacing prose">
    <div class="article-feed__heading m-auto 3xl:max-w-block-wide">
      <h2
        v-if="heading"
        class="h3 mt-0"
      >
        {{ heading }}
      </h2>
    </div>

    <UiLoaderOverlay :pending="pending">
      <ArticleListingBlock
        :show-article-summaries="showArticleSummaries"
        :show-article-topics="showArticleTopics"
        :cards="articles"
      />
    </UiLoaderOverlay>
  </div>
</template>
